var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[(_vm.show())?_c('circle',{class:{ 
        'network-background': ((!_vm.selected && (_vm.circleType === 'Capacity' || _vm.circleType === 'CTAB')) || (_vm.circleType === 'OH')),
        'network-flow': (!_vm.selected && _vm.circleType === 'Flow'),
        'network-fixed': (!_vm.selected && _vm.circleType === 'FixedFlow'),
        'network-infeasible': (!_vm.selected && _vm.circleType === 'InfeasibleFlow'),
        'network-selection': _vm.selected
    },attrs:{"cx":_vm.getX(),"cy":_vm.getY(),"r":_vm.radius()},on:{"click":function($event){return _vm.selectMapObject(_vm.item, null)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }